module.exports = __webpack_public_path__ + "static/media/icon_service_03_pc.b6368f46.webp";